export const searchThemesFromTrends = {
    description:
        'You can view the analysis results of market attention for each theme.\n' +
        'Additionally, you can narrow down the target themes to display on the bubble chart.\n' +
        'In addition, you can check the top 10 themes in terms of recent patent application numbers or total investment amount.',
    subtitle: 'Theme trends',
    subDescription: 'You can explore themes with high investment growth rates and patent application growth rates.',
    vectorSearchDescription:
        'Themes considered highly relevant to the search keyword are mechanically extracted based on vector similarity.\nIf the results do not seem convincing, please use "Filter by category."',

    filterLabel: 'Filter the displayed theme categories',
    placeholder: 'Select a category',

    // バブルチャート
    chartTitle: 'Theme trends',
    copy: 'Copy',
    labelFixedMsg: 'Please turn off "Label Fix" when you want to select a theme.',
    setting: 'Configuration',
    aboutXAxis: 'About the X-axis settings',
    aboutYAxis: 'About the Y-axis settings',
    patentCount: 'Number of Patent Applications',
    growthRatePatentCount: 'Patent application growth rate',
    growthRateInvestmentAmount: 'Investment growth rate',
    investmentAmount: 'Total investment amount',
    businessAmount: 'Business Scale',
    noDisplay: 'Do not fix the labels',
    labelShowOnly: 'Theme Name',
    labelShowMore: 'Theme name and number of patent applications',

    // タブ
    themeList: 'Theme List',
    timeSeriesOfPatent: 'Time Series of Patent Applications',
    timeSeriesOfInvestmentAmount: 'Time Series of Total investment amount',

    vectorSearchLabel: 'Filter themes with AI',
    categorySearchLabel: 'Filter by category',
    vectorSearchPlaceholder: 'e.g. electricity, semiconductor, pharmaceutical...',
    vectorSearchButton: 'Search',
    topNLabel: 'Number of results'
}
